import { Chip } from "@mui/material";
import axios from "axios"
import { useEffect } from "react";
import { fblink } from '../config/config';
function Genres({
  selectedGenres,
  setSelectedGenres,
  genres,
  setGenres,
  type,
  setPage
}) {

  const fetchGenres = async () => {
    const { data } = await axios.get(`${fblink}/category/genres.json`);
	
    setGenres(data);
  }
  useEffect(() => {
    fetchGenres();
  }, [])
  const handleAdd = (genre) => {
	setSelectedGenres([genre]);
    setPage(1);
  }
  const handleRemove = (genre) => {
    setPage(1);
  }
  return (
    <div style={{ marginBottom: '24px' }}>
      {selectedGenres && selectedGenres.map((genre) => {
        return <Chip
          style={{ margin: 2 }}
          label={genre.name}
          key={genre.id}
          clickable
          size="small"
          color="primary"
          onDelete={() => handleRemove(genre)}
        />
      })
      }
      {genres && genres.map((genre) => {
        return <Chip
          style={{ margin: 2 }}
          label={genre.name}
          key={genre.id}
          clickable
          size="small"
          onClick={() => handleAdd(genre)}
        />
      })
      }
    </div>
  )
}

export default Genres